import { Clock3, Layers3, Play, Timer, Video } from 'lucide-react'
import { ExerciseMedia, safeVideoUrl } from '../../components/ExerciseMedia'
import { useStrata } from '../../data/StrataProvider'
import type { WorkoutTemplate } from '../../domain/types'

export function WorkoutPreview({ template, onStart }: { template: WorkoutTemplate; onStart: () => void }) {
  const { state } = useStrata()
  const totalSets = template.entries.reduce((sum, entry) => sum + entry.sets, 0)

  return (
    <div className="workout-preview">
      <header className="preview-hero">
        <span className="eyebrow">{dayName(template.weekday).toUpperCase()}</span>
        <h2>{template.name}</h2>
        <p>{template.focus}</p>
        <div className="preview-metrics">
          <span><Clock3 size={14} /> {template.minutes} min</span>
          <span><Layers3 size={14} /> {totalSets} series</span>
          <span>{template.entries.length} ejercicios</span>
        </div>
      </header>

      <div className="preview-list">
        {template.entries.map((entry, index) => {
          const exercise = state.exercises.find((item) => item.id === entry.exerciseId)!
          const videoUrl = safeVideoUrl(exercise.videoUrl)
          return (
            <article className="preview-exercise" key={entry.exerciseId}>
              <span className="preview-number">{String(index + 1).padStart(2, '0')}</span>
              <ExerciseMedia exercise={exercise} size={64} />
              <div className="preview-copy">
                <strong>{exercise.name}</strong>
                <span>{entry.sets} × {entry.minReps}–{entry.maxReps} {entry.repUnit === 'min' ? 'min' : ''} · RIR {entry.targetRir}</span>
                <small>{entry.cue}</small>
                <div><em><Timer size={12} /> {clock(entry.restSeconds)}</em>{videoUrl && <a href={videoUrl} target="_blank" rel="noreferrer"><Video size={12} /> Video</a>}</div>
              </div>
            </article>
          )
        })}
      </div>

      <button className="primary-button preview-start" onClick={onStart}><Play size={17} fill="currentColor" />Iniciar {template.name}</button>
    </div>
  )
}

const days = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
const dayName = (weekday: number) => days[weekday] ?? 'Domingo'
const clock = (value: number) => `${Math.floor(value / 60)}:${String(value % 60).padStart(2, '0')}`
